import React from "react";
import {Manufacturer} from "features/healthcheck/types";

const ManufacturerSelect = ({label, manufacturers, value, valueSetter}: { label: string, manufacturers: Manufacturer[], value: string, valueSetter: (v: string) => void}) => {
    return (
        <div className="excel-input-container">
            <label>{label}</label>
            <select className="inputs-container" value={value} onChange={(e) => {
                valueSetter(e.target.value)
            }}>
                <option value="" disabled>-- Select a manufacturer --</option>
                {manufacturers.sort((m1, m2) => m1.manufacturer.localeCompare(m2.manufacturer)).map((m) => (
                    <option key={m.manufacturer} value={m.manufacturer}>
                        {m.manufacturer}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ManufacturerSelect;